import { ConfigContaProyectosService } from 'src/app/services/ConfigContaProyectos.service';
import { StorageService } from 'src/app/services/storage.service';
import { TableFunctionService } from 'src/app/services/table-function.service';
import { ModalBusquedaPlanCuentasComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-plan-cuentas/modal-busqueda-plan-cuentas.component';
import { SubCentroCostosService } from 'src/app/services/sub-centro-costos.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ModalBusquedaProyectosComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proyectos/modal-busqueda-proyectos.component';
import { ModalBusquedaSubCentroComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-sub-centro/modal-busqueda-sub-centro.component';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistroComprasService } from 'src/app/services/registro-compras.service';
import { obtenerFechaActual, basicAlert, obtenerFechaSeleccionada, alertaConfirmacionHTML, timerOut, obtenerDias, validarCodigoExistentesRC, filtrarCoincidenciaArrayCuenta, alertaRouter, alertaConfirmacion, filtrarCoincidenciaArrayDocume } from 'src/app/shared/utils';
import { Location } from '@angular/common';
import { PlanCuentaService } from 'src/app/services/plancuenta.service';
import { NgbActiveModal, NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import { DataService } from 'src/app/services/dataService.service';
import { InterlocutorService } from 'src/app/services/iInterlocutor.service';
import { ModalBusquedaInterlocutorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-interlocutor/modal-busqueda-interlocutor.component';
import { ProveedorService } from 'src/app/services/proveedor.service'
import { ModalBusquedaProveedorComponent } from 'src/app/shared/modals/busqueda/modal-busqueda-proveedor/modal-busqueda-proveedor.component';
import { DocumentosCobranzaService } from 'src/app/services/documentos-cobranza.service'
import { ModalBusquedaTdocumentosComponent } from '../busqueda/modal-busqueda-tdocumentos/modal-busqueda-tdocumentos.component';
import { CuentaPorCobrarService } from 'src/app/services/cuentaporcobrar.service'
import { TDocumeRestService } from 'src/app/services/TDocume.service'
import { BuscarService } from 'src/app/services/buscar.service';
import { TableService } from 'src/app/services/ngtable.service';

@Component({
  selector: 'app-md-doc-serienumero',
  templateUrl: './md-doc-serienumero.component.html',
  styleUrls: ['./md-doc-serienumero.component.scss']
})
export class MdDocSerienumeroComponent implements OnInit {

  @Input() listadata: any[] = [];
  @Input() interlocutores_temp: any[] = [];
  @ViewChild('codArticuloI') codArticuloInput: ElementRef;

  constructor(
    private tableFunction: TableFunctionService,
    private proyectoService: ConfigContaProyectosService,
    private SubCentroCostosService: SubCentroCostosService,
    private spinnerService: SpinnerService,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private _location: Location,
    private router: Router,
    private cuentasService: PlanCuentaService,
    private registroComprasService: RegistroComprasService,
    private storageService: StorageService,
    private modalServicemodal: NgbActiveModal,
    private decimalPipe: DecimalPipe,
    private DataService : DataService,
    private interlocutorService: InterlocutorService,
    private proveedorService: ProveedorService,
    private documentosCobranzaService: DocumentosCobranzaService,
    private CuentaPorCobrarService: CuentaPorCobrarService,
    private TDocumeRestService: TDocumeRestService,
    private _buscarService: BuscarService,
    private TableService: TableService,
  ) { }

  detalleadicionar: any[] = [];
  

  ngOnInit(): void {
    this.TableService.tableList = this.interlocutores_temp;
    setTimeout(() => {
      //this.dtTrigger.next();  
   
      this.spinnerService.activarLoading(false);
    }, 500);

    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });
  }

  _csearchTerm: string='';
  get csearchTerm(): string {
    
    return this._csearchTerm;
  }

  set csearchTerm(val: string) {
    this._csearchTerm = val;
    
    this.listadata = this.cfilter(val);

    console.log("Valores filtrados: ") 
    console.log(this.listadata)

    // this.totalLengthOfCollection = this.cfilterClient.length;
  }

  onChange(val: any){

    timerOut(1000).then((value: any) => {
      if (value) {
        if(this._csearchTerm == '' || this._csearchTerm == null ){
          console.log("DEVOLVIENDO VALORES")
          console.log(this.interlocutores_temp)
          this.listadata = this.interlocutores_temp;
        }
      }
    });

  }

  cfilter(v: string) {
    if(this._csearchTerm == ''){
      this.listadata = this.interlocutores_temp;
      return this.listadata;
    }

    console.log("Valor a Buscar: " + this._csearchTerm)

    return this.TableService.getTable().filter(x => x.codcli.indexOf(v) !== -1  ||
    x.razonc?.toString().toLowerCase().indexOf(v.toLowerCase()) !== -1 || 
    x.tidentNombre?.toString().toLowerCase().indexOf(v) !== -1);

  }

  openModalAdicionar(): void {
    this.spinnerService.activarLoading(true);
    this.modalServicemodal.close(this.ItemChecado);
    //this.dtTrigger.unsubscribe();
  }
  cancelar() {
    this.modalServicemodal.dismiss('canceling');
  }
  onNexFocus(){

  }



    index: number = 0;

  onChangeInputCheckbox($event, data: any){
    console.log($event)
    if($event){
    this.detalleadicionar[this.index] = data;
    this.index++;
    }
    else{
      this.detalleadicionar = this.detalleadicionar.filter(x => (x.periodo !== data.periodo || x.mes !== data.mes || x.libro !== data.libro || x.asiento !== data.asiento || x.item !== data.item || x.sitem !== data.sitem));
      this.index--;
    }
    console.log("this.cuentas por cobrar cargadas")
    console.log(this.detalleadicionar)
  }
  
  ItemChecado: any
  ItemSeleccionado: boolean = false;
  onChangeItem(coti: any) {
    this.ItemChecado = coti;
    console.log(this.ItemChecado);
    this.ItemSeleccionado = true;
  }

}
